import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ReportDashboardService {
  url = '/api/dashboardExtensions';

  constructor(private http: HttpClient) {}

  delete(dashboardId: string): Observable<Object> {
    let data = { DashboardId: dashboardId };
    return this.http.post<boolean>(this.url+'/deleteDashboard', data);
  }

  setAsDefault(dashboardId: string): Observable<Object> {
    let data = { DashboardId: dashboardId };
    return this.http.post<boolean>(this.url+"/setAsDefaultDashboard", data);
  }
}
